import { memo } from 'react';

import { tailwindVariants } from '@air/utils-tailwind';

const MAIN_SIDE_NAV_ITEM_BADGE_MAX_COUNT = 99;

export const mainSideNavItemCountBadge = tailwindVariants({
  base: 'absolute -top-2 -right-2 flex h-4 min-w-4 items-center justify-center rounded-full px-0.5 font-bold text-8 tabular-nums',
  defaultVariants: {
    tone: 'default',
  },
  variants: {
    tone: {
      default: 'ads:bg-primary-subtle bg-altitude-3 ads:text-accent text-altitude-11',
      warning: 'ads:bg-warning bg-amber-3 ads:text-warning text-amber-11',
    },
  },
});

export type MainSideNavItemCountBadgeTone = 'default' | 'warning';

export type MainSideNavItemCountBadgeProps = {
  count: number;
  'data-testid': string;
  tone?: MainSideNavItemCountBadgeTone;
};

export const MainSideNavItemCountBadge = memo(
  ({ count, 'data-testid': dataTestId, tone = 'default' }: MainSideNavItemCountBadgeProps) => {
    const label = count > MAIN_SIDE_NAV_ITEM_BADGE_MAX_COUNT ? `${MAIN_SIDE_NAV_ITEM_BADGE_MAX_COUNT}+` : String(count);

    return (
      <span className={mainSideNavItemCountBadge({ tone })} data-testid={dataTestId}>
        {label}
      </span>
    );
  },
);

MainSideNavItemCountBadge.displayName = 'MainSideNavItemCountBadge';
